import { SignInOption } from '~/modules/sign-in/types/sign-in-option.type';

export interface SignInOptionsResponse {
  claimedDomain: boolean;
  signInOptions: Array<SignInOption>;
}

export class SignInService {
  static $inject = ['AuthOptionsService'];

  constructor(private AuthOptionsService) {}

  public getSignInOptions(email: string): angular.IPromise<SignInOptionsResponse> {
    return this.AuthOptionsService.getSignInOptions(email);
  }

  public getSignInOptionsWithAccountId(accountId: string): angular.IPromise<SignInOptionsResponse> {
    return this.AuthOptionsService.getSignInOptions(accountId, { org_name: true });
  }

  public authEmailOrUserParam(stateParams) {
    return stateParams.auth_email || stateParams.auth_username || '';
  }
}
